export enum SortBy {
  Name = "Name",
  LastContactDate = "LastContactDate",
  OldestContact = "OldestContact",
  Relevance = "Relevance"
}

export enum BookingKitSortBy {
  BookingDate = "BookingDate",
  CreatedOn = "CreatedOn",
  TimereportCreatedOn = "TimereportCreatedOn",
  TimereportApprovedOn = "TimereportApprovedOn"
}

export enum AccommodationRequestSortBy {
  CreatedOn = "CreatedOn",
  FirstArrivalDate = "FirstArrivalDate",
}

export enum TravelRequestSortBy {
  CreatedOn = "CreatedOn",
  FirstDepartureDate = "FirstDepartureDate",
}
